import { render, staticRenderFns } from "./KeybeIcon.vue?vue&type=template&id=2ec6f80f&"
import script from "./KeybeIcon.vue?vue&type=script&lang=ts&"
export * from "./KeybeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports